const rules = {
  email: /^[0-9a-zA-Z-_.]+@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,}$/,
  isAlphabet: /[A-Za-z]/gm,
  isNumber: /[0-9]/gm,
  isAbleCode: /[`!~#@$%\^&*()_+\-=[\];',./{}:"<>?\\\|]/gm,
  isUnAbleCode: /[^A-Za-z0-9가-힣ㄱ-ㅎㅏ-ㅣ\x20\s`!~#@$%\^&*()_+\-=[\];',./{}:\\"<>?\\|]/gm,
  dateString: /([12]\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))/,
  telNumber: /^[0-9]*$/,
  isHangul: /[가-힣ㄱ-ㅎㅏ-ㅣ]/,
  isDeprecatedProductDetail: /^\/ko\/product\/([A-Za-z0-9-]+)\/([A-Z0-9-]+)$/
};

export const validEmail = (rule, value, cb) => {
  if (rules.email.test(value)) { cb(); }
  else { cb(true); }
};

export const validPasswd = (value) => {
  const hasAlphabet = rules.isAlphabet;
  const hasNumber = rules.isNumber;
  const hasAbleCode = rules.isAbleCode;
  const unableCode = rules.isHangul;
  let error = null;
  let result = true;
  let union = 0;

  if(value.match(hasAlphabet)) union++;
  if(value.match(hasNumber)) union++;
  if(value.match(hasAbleCode)) union++;

  if (value.match(/\s/g)
    || value.match(unableCode)
    || value.length > 20) {
    error = 'error';
    result = false;
  }

  return {result, error};
};

export const onlyAbleCode = (rule, value, cb) => {
  rules.isUnAbleCode.test(value) ? cb(false) : cb();
};

export { rules }
